import Task from 'models/task/Task';

function makeRelative(value: number, unit: Intl.RelativeTimeFormatUnit, locale: string) {
	const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

	return rtf.format(value, unit);
}

function makeDuration(value: number, unit: Intl.RelativeTimeFormatUnit, locale: string) {
	const df = new (Intl as any).DurationFormat(locale, { style: 'long' });

	if (locale.startsWith('pl') && unit === 'day') {
		const nf = new Intl.NumberFormat(locale);
		const pr = new Intl.PluralRules(locale, { type: 'cardinal' });
		const rule = pr.select(value);

		const label = rule === 'one' ? 'dzień' : 'dni';

		return `${nf.format(value)} ${label}`;
	}

	return df.format({ [`${unit}s`]: value });
}

function diffIn(unit: Intl.RelativeTimeFormatUnit, from: Date, to: Date) {
	const ms = to.getTime() - from.getTime();
	const mins = ms / (1000 * 60);

	if (unit === 'minute') return Math.floor(mins);
	if (unit === 'hour') return Math.floor(mins / 60);
	if (unit === 'day') return Math.floor(mins / 60 / 24);

	return mins;
}

function diffCalendarDays(from: Date, to: Date) {
	const a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
	const b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());

	return Math.trunc((b - a) / (24 * 60 * 60 * 1000));
}

export function taskAvailability(task: Task, locale: string) {
	const now = new Date();
	let start = task.startAt();
	let end = task.endAt();

	if (!start && !end) {
		return null;
	}

	start = task.startAt().toDate();
	end = task.endAt().toDate();

	// --- before ---
	if (now < start) {
		const diffminute = diffIn('minute', now, start);
		const diffhour = diffIn('hour', now, start);
		const diffday = diffCalendarDays(now, start);

		if (diffhour < 1) {
			return { id: 'scheduled', values: { time: makeRelative(diffminute, 'minute', locale) } };
		}
		if (diffhour < 24) {
			return { id: 'scheduled', values: { time: makeRelative(diffhour, 'hour', locale) } };
		}
		if (diffday < 2) {
			return { id: 'scheduled-tomorrow', values: {} };
		}
		if (diffday < 365) {
			return { id: 'scheduled', values: { time: makeRelative(diffday, 'day', locale) } };
		}

		return { id: 'scheduled-soon', values: {} };
	}

	// --- in progress ---
	if (now < end) {
		const diffminute = diffIn('minute', now, end);
		const diffhour = diffIn('hour', now, end);
		const diffday = diffIn('day', now, end);

		if (diffday >= 1) {
			return { id: 'available', values: { time: makeDuration(diffday, 'day', locale) } };
		}
		if (diffhour >= 1) {
			return { id: 'available', values: { time: makeDuration(diffhour, 'hour', locale) } };
		}

		return { id: 'available', values: { time: makeDuration(diffminute, 'minute', locale) } };
	}

	// --- expired ---
	return { id: 'expired', values: {} };
}
